import React from 'react'
import styled from 'styled-components';
import Img1 from '../../assets/Images/CyptoWallet.png';
import Img2 from '../../assets/Images/24-7Support.png';
import Img3 from '../../assets/Images/InviteFriends.png';
import './Index.css'

const Text = styled.p`
    text-align: center;
    font-weight: 600;
    color: ${({ theme }) => theme.text};

    .color{
        color: #0d6efd;
    }
`;
const Div = styled.div`
    margin-top: -200px;

    @media (max-width: 1000px){
        margin-top: -325px;    
    }
    @media (max-width: 999px){
        margin-top: -415px;    
    }
    @media (max-width: 876px){
        margin-top: -440px;    
    }
    @media (max-width: 675px){
        margin-top: -375px;    
    }
    @media (max-width: 666px){
        margin-top: -330px;
    }
    @media (max-width: 454px){
        margin-top: -290px;
    }
    @media (max-width: 360px){
        margin-top: -230px;
    }
`

const arr = [{

    img: Img1,
    heading: 'Free Bitcoin and Crypto wallet',
    title: 'Get a free Qvani wallet when you sign up to send, receive, and store your Bitcoin or cryptocurrency safely.'
},
{
    img: Img2,
    heading: '24/7 Support',
    title: 'You can always contact our 24/7 support team by messaging or depending on the hours, with a real live support agent. You can also check out our Help Center.'
},
{
    img: Img3,
    heading: 'Invite Friends & Earn',
    title: 'Qvani Referral Rewards Program helps you bring financial freedom to your community. Refer friends to trade on Qvani and receive commission from their trades.'
},
]


export default function Card() {
    return (
        <Div className='container-fluid' >
            <div className='row m-0 d-flex flex-column align-items-center justify-content-center'>
                <div className=' col-md-6 col-sm-12'>
                    <Text className='fs-1 fw-bold text-center'>Qvani is the <span className='color'>safest place</span> <br /> to <span className='color'>trade, send</span> and <span className='color'>receive crypto</span></Text>
                </div>
            </div>
        </Div>
    );
}